import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function MenuIcon({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path
                d="M19 3V4H16V3V2H19V3ZM14 5H15V8H14H13V5H14ZM16 10V9H19V10V11H16V10ZM21 8H20V5H21H22V8H21ZM19 10V9C19.5523 9 20 8.55228 20 8H21H22C22 9.65685 20.6569 11 19 11V10ZM14 8H15C15 8.55228 15.4477 9 16 9V10V11C14.3431 11 13 9.65685 13 8H14ZM16 3V4C15.4477 4 15 4.44772 15 5H14H13C13 3.34315 14.3431 2 16 2V3ZM19 3V2C20.6569 2 22 3.34315 22 5H21H20C20 4.44772 19.5523 4 19 4V3Z"
                fill={color}/>
            <path
                d="M19 14V15H16V14V13H19V14ZM14 16H15V19H14H13V16H14ZM16 21V20H19V21V22H16V21ZM21 19H20V16H21H22V19H21ZM19 21V20C19.5523 20 20 19.5523 20 19H21H22C22 20.6569 20.6569 22 19 22V21ZM14 19H15C15 19.5523 15.4477 20 16 20V21V22C14.3431 22 13 20.6569 13 19H14ZM16 14V15C15.4477 15 15 15.4477 15 16H14H13C13 14.3431 14.3431 13 16 13V14ZM19 14V13C20.6569 13 22 14.3431 22 16H21H20C20 15.4477 19.5523 15 19 15V14Z"
                fill={color}/>
            <path
                d="M8 3V4H5V3V2H8V3ZM3 5H4V8H3H2V5H3ZM5 10V9H8V10V11H5V10ZM10 8H9V5H10H11V8H10ZM8 10V9C8.55228 9 9 8.55228 9 8H10H11C11 9.65685 9.65685 11 8 11V10ZM3 8H4C4 8.55228 4.44772 9 5 9V10V11C3.34315 11 2 9.65685 2 8H3ZM5 3V4C4.44772 4 4 4.44772 4 5H3H2C2 3.34315 3.34315 2 5 2V3ZM8 3V2C9.65685 2 11 3.34315 11 5H10H9C9 4.44772 8.55228 4 8 4V3Z"
                fill={color}/>
            <path
                d="M8 14V15H5V14V13H8V14ZM3 16H4V19H3H2V16H3ZM5 21V20H8V21V22H5V21ZM10 19H9V16H10H11V19H10ZM8 21V20C8.55228 20 9 19.5523 9 19H10H11C11 20.6569 9.65685 22 8 22V21ZM3 19H4C4 19.5523 4.44772 20 5 20V21V22C3.34315 22 2 20.6569 2 19H3ZM5 14V15C4.44772 15 4 15.4477 4 16H3H2C2 14.3431 3.34315 13 5 13V14ZM8 14V13C9.65685 13 11 14.3431 11 16H10H9C9 15.4477 8.55228 15 8 15V14Z"
                fill={color}/>
        </svg>
    );
}

export default MenuIcon;
